module.exports = __webpack_public_path__ + "static/media/icon-excel.7d7a2baa.svg";